import { BaseAPI } from './BaseAPI';
import { BlockInfo, ValidatorSet } from '../../../core';

export class TendermintAPI extends BaseAPI {
  public async nodeInfo(): Promise<object> {
    return this.c.getRaw(`/node_info`);
  }

  public async syncing(): Promise<boolean> {
    return this.c.getRaw<{ syncing: boolean }>(`/syncing`).then(d => d.syncing);
  }

  public async validatorSet(height?: number): Promise<ValidatorSet> {
    let url =
      height !== undefined
        ? `/validatorsets/${height}`
        : `/validatorsets/latest`;
    return this.c.get<ValidatorSet>(url).then(d => d.result);
  }

  public async block(height?: number): Promise<BlockInfo> {
    let url = height !== undefined ? `/blocks/${height}` : `/blocks/latest`;
    return this.c.getRaw<BlockInfo>(url);
  }
}
